import script from "./EditColumnTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditColumnTable.vue?vue&type=script&lang=ts&setup=true"

import "./EditColumnTable.vue?vue&type=style&index=0&id=bd54f872&lang=css"

const __exports__ = script;

export default __exports__